import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { fetchCompanyData } from "../../redux/slice/CompanySlice/CompanySlice";
import CustomGrid from "../../components/common/CustomGrid/CustomGrid";

function CompaniesEquipment() {
    const [alldata, setAlldata] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const dispatch = useDispatch();
    // const navigate = useNavigate();

    const { CompanyData } = useSelector((state) => state?.Companies);

    useEffect(() => {
        dispatch(fetchCompanyData());
    }, [dispatch]);

    useEffect(() => {
        setAlldata(CompanyData || []);
        setFilteredData(CompanyData || []);
    }, [CompanyData]);

    const handleFilterChange = (event) => {
        const value = event.target.value.toLowerCase();
        setFilterText(value);
        const filtered = alldata.filter(
            (item) =>
                item.companyName.toLowerCase().includes(value) ||
                item.email.toLowerCase().includes(value) ||
                item.phoneNumber.toLowerCase().includes(value)
        );
        setFilteredData(filtered);
    };

    // Fixed columns for react-table / CustomGrid
    const columns = [
        { Header: "Company Name", accessor: "companyName" },
        { Header: "Email", accessor: "email" },
        { Header: "Phone Number", accessor: "phoneNumber" },
        {
            Header: "Equipments Cut",
            accessor: "equipments",
            disableSortBy: true,
            Cell: () => (
                <div className="flex items-center">
                    <button
                        className="btn btn-outline-secondary mx-2 "
                    // onClick={() => {
                    //     setSelectedRow(cell?.row?.original);
                    //     navigate("/sites/sites-view", {
                    //         state: {
                    //             data: cell?.row?.original?._id,
                    //             type: "equipment",
                    //         },
                    //     });
                    // }}
                    >
                        View
                    </button>
                </div>
            ),
        },
    ];

    return (
        <div className="companies-container">
            {/* Search + New button */}
            <div className="companies-header d-flex justify-content-between align-items-center mb-4 gap-3 flex-wrap">
                <input
                    type="text"
                    className="form-control search-input"
                    placeholder="Search By Name, Email or Phone"
                    value={filterText}
                    onChange={handleFilterChange}
                />
            </div>

            {/* Table */}
            <CustomGrid columns={columns} data={filteredData} />
        </div>
    );
}

export default CompaniesEquipment;
